import React from 'react';
import * as GlobalVariables from '../config/GlobalVariableContext';
import { ButtonSolid, ScreenContainer, withTheme } from '@draftbit/ui';
import { StyleSheet, Text, TextInput, View } from 'react-native';

const PracticenoticingParentScreen = props => {
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();

  const { theme } = props;
  const { navigation } = props;

  const [checkboxRowValue, setCheckboxRowValue] = React.useState('');
  const [checkboxRowValue2, setCheckboxRowValue2] = React.useState('');
  const [checkboxValue, setCheckboxValue] = React.useState(false);
  const [radioButtonGroupValue, setRadioButtonGroupValue] = React.useState('');
  const [radioButtonGroupValue2, setRadioButtonGroupValue2] =
    React.useState('');
  const [starRatingValue, setStarRatingValue] = React.useState(0);
  const [styledTextAreaValue, setStyledTextAreaValue] = React.useState('');
  const [styledTextFieldValue, setStyledTextFieldValue] = React.useState('');
  const [textAreaValue, setTextAreaValue] = React.useState('');
  const [textInputValue, setTextInputValue] = React.useState('');
  const [textInputValue2, setTextInputValue2] = React.useState('');

  return (
    <ScreenContainer hasSafeArea={false} scrollable={false}>
      <View>
        <Text style={[styles.Textc3594145, { color: theme.colors.strong }]}>
          {'What cues did you notice?'}
        </Text>
      </View>

      <View
        style={[
          styles.View4949b09e,
          { backgroundColor: theme.colors.background },
        ]}
      >
        {/* ParentCues */}
        <Text style={[styles.Text8acc43bb, { color: theme.colors.strong }]}>
          {'You (Parent)\n'}
        </Text>
        {/* ParentCuesTextBox */}
        <TextInput
          onChangeText={newParentCuesTextBoxValue => {
            try {
              setGlobalVariableValue({
                key: 'parentCues',
                value: newParentCuesTextBoxValue,
              });
            } catch (err) {
              console.error(err);
            }
          }}
          style={[
            styles.TextInput8dfb84d1,
            {
              borderColor: theme.colors.strong,
              backgroundColor: theme.colors.background,
            },
          ]}
          placeholder={'What was the context?'}
          multiline={true}
          numberOfLines={4}
          defaultValue={Constants['parentCues']}
        />
      </View>

      <View style={styles.Viewb2459fe7}>
        <ButtonSolid
          onPress={() => {
            try {
              navigation.navigate('PracticenoticingChildScreen');
            } catch (err) {
              console.error(err);
            }
          }}
          style={[
            styles.ButtonSolid2d5f6a36,
            { backgroundColor: theme.colors.primary },
          ]}
          title={'Next'}
        />
      </View>
    </ScreenContainer>
  );
};

const styles = StyleSheet.create({
  ButtonSolid2d5f6a36: {
    borderRadius: 8,
    fontFamily: 'System',
    fontWeight: '700',
    textAlign: 'center',
  },
  Text8acc43bb: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 17,
    textAlign: 'center',
  },
  TextInput8dfb84d1: {
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRadius: 8,
    borderRightWidth: 1,
    borderTopWidth: 1,
    paddingBottom: 8,
    paddingLeft: 8,
    paddingRight: 8,
    paddingTop: 8,
    textAlign: 'center',
  },
  Textc3594145: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 28,
    marginTop: 20,
    textAlign: 'center',
  },
  View4949b09e: {
    alignContent: 'center',
    justifyContent: 'space-evenly',
    marginLeft: 10,
    marginRight: 10,
    marginTop: 100,
  },
  Viewb2459fe7: {
    marginLeft: 100,
    marginRight: 100,
    marginTop: 50,
  },
});

export default withTheme(PracticenoticingParentScreen);
